import {Form as AntForm, Input} from 'antd';
import {debounce} from 'lodash-es';
import React, {useEffect, FC} from 'react';

import {TEntity, selectEntityData} from 'modules/data';
import {performActionForSearch} from 'modules/data/data-actions';
import {IFilterEntityData, ISearchEntityData} from 'modules/data/data-types';
import {ReactComponent as SearchIcon} from 'shared/assets/search.svg';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

import './search.less';

interface ISearchProps {
    parentEntityType?: EEntityType;
    entityName: string;
    data?: IFilterEntityData;
    url?: string;
}

export const Search: FC<ISearchProps> = ({
    entityName,
    url,
    parentEntityType,
    ...props
}: ISearchProps) => {
    const [form] = AntForm.useForm();
    const dispatch = useAppDispatch();
    const search = useAppSelector(selectEntityData(entityName, EEntityType.SEARCH)) as ISearchEntityData;

    // при переходе в другой раздел и обратно значение должно быть сохранено
    useEffect(() => {
        form.setFieldsValue(search?.data);
    }, []);

    const debouncedDispatch = debounce(dispatch, 300);

    const handleValuesChanges = (values: TEntity) => {
        debouncedDispatch(performActionForSearch({
            entityName,
            newEntityTypeData: values,
            url,
            parentEntityType,
        }));
    };

    return (
        <AntForm
            {...props}
            className="search"
            colon={false}
            layout="inline"
            form={form}
            onValuesChange={handleValuesChanges}
        >
            <AntForm.Item
                name="search"
                className="search__wrapper"
            >
                <Input
                    className="search__container"
                    placeholder="Поиск"
                    prefix={<SearchIcon className="search__icon" />}
                    bordered={false}
                />
            </AntForm.Item>
        </AntForm>
    );
};
